import { EnumMultiSelectFieldProps } from "./EnumMultiSelectField";
import {
  Option,
  EnumMultiSelectFieldValue,
  EnumMultiSelectFieldSingleValue,
} from "../../types/fieldTypes";
import React from "react";

export const useEnumMultiSelectField = (props: EnumMultiSelectFieldProps) => {
  const selectAllOption: Option<EnumMultiSelectFieldSingleValue> = {
    label: "Select All",
    value: 9999,
  };

  const valueWithSelectAll =
    (props.optionValues || []).length === (props.value || []).length
      ? [...(props.value || []), ...[selectAllOption.value]]
      : props.value;

  const setInitialFieldValue = (includeSelectAll = false) => {
    if (!!includeSelectAll) {
      return valueWithSelectAll;
    } else {
      return props.value;
    }
  };
  const [localValue, setLocalValue] = React.useState<EnumMultiSelectFieldValue>(
    setInitialFieldValue(props.includeSelectAll) || []
  );

  const localOptionValues: Option<EnumMultiSelectFieldSingleValue>[] = [
    ...(props.optionValues || []),
    ...[selectAllOption],
  ];

  return { localValue, setLocalValue, localOptionValues, selectAllOption };
};
